import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
// import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
// import ButtonBase from '@material-ui/core/ButtonBase';
// import GridList from '@material-ui/core/GridList';
// import GridListTile from '@material-ui/core/GridListTile';
// import GridListTileBar from '@material-ui/core/GridListTileBar';

import {TEST} from '../actions/ActionTypes';
import { connect } from "react-redux";
import { compose } from "redux";
const { innerWidth } = window;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    centerText: {
        textAlign: 'center'
    },
    justifyText: {
        textAlign: 'justify'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    fontOptions: {
        lineHeight: 1.8,        
    },
    headerTextColor: {
        color: '#1E1759',
        fontWeight: 'bold',
        lineHeight: 1.8, 
    },
    paragraphTextColor: {
        color: '#888',
        fontWeight: 300,
        fontSize: 15
    },
    image: {
        top: "79%",
        width: "100%",
        position: 'relative',
        transform: 'translateY(-50%)'
    },
    gridList: {
        flexWrap: 'nowrap',
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
});

class Home extends Component {
    constructor(){
        super();
        this.state = {
            tileData: [
                {
                    img: require('../assets/4.jpg'),
                    title: "Avanti Ramraj",
                    description: "Avanti is a gregarious, personality-packed young lady. She enjoys basketball, playing the piano and cooking. Her forte lies in science and math. She is learning bharatnatyam (a classical Indian dance form) that requires hard work and dedication. When she grows up she wants to be a doctor and use her scientific mind and empathetic heart to help others. She is eloquent and makes a great spokesperson for the Thunderbots."
                },
                {
                    img: require('../assets/1.jpg'),
                    title: "Diya Iyer",
                    description: "Diya is a high energy yet calm and composed girl. She channels her energy by doing gymnastics. She de-stresses by playing the piano. She loves dogs and wants to adopt one soon. She is altruistic and wants to volunteer at shelters. She likes almost everything about school. She is an easy going team player. She isnt sure what she wants to do when she grows up. She wants to be a contributing citizen who helps the community. Her problem-solving abilities are essential to the success of the Thunderbots."
                },
                {
                    img: require('../assets/2.jpg'),
                    title: "Easha Narayanan",
                    description: "Easha has formidable chess skills which you would never guess as she is modesty personified. She loves bharatnatyam and anything related to art. She has a very inquisitive mind, which would be perfect for the professions she is considering, namely lawyer or doctor. She is a very good sport and is willing to take on any role in a team. She has a high need for achievement and strives hard to attain her goals. She loves to come up with creative solutions and is a great value-add to the Thunderbots."
                },
                {
                    img: require('../assets/3.jpg'),
                    title: "Samyukta Sudheer",
                    description: "Samyukta aka Samy is a cat-loving, tennis-playing, comic-reading, TV-watching, seemingly shy girl. But after spending 5 minutes with her, you can see her gears are constantly turning. She has a keen and sharp mind that doesn�t miss much. Her passion for science and compassion for others make her a perfect candidate for the profession she has chosen - a doctor. She has yet to decide the specialization. But then, considering she is only in 5th grade she has ample time to make up her mind. As part of the Thunderbots, Samy excels at building and team-building activities."
                }
            ]
        }
    }

    componentDidMount() {
        this.props.dispatch({type: TEST, data: true});        
    }

    render(){
        const { classes } = this.props;

        return(
            <div className={classes.root}>
                <Grid container spacing={24}>
                    {
                        innerWidth <= 480 
                        ? null 
                        : <Grid item xs={2} className={classes.centerText}></Grid>
                    }
                    
                    <Grid item xs={innerWidth <= 480 ? 12 : 8} className={classes.centerText}>
                        <Typography variant="h4" color="inherit" className={`${classes.grow} ${classes.headerTextColor}`}>
                            About the STEM Learning Exchange program
                        </Typography>
                        <Typography variant="caption" color="inherit" className={`${classes.grow} ${classes.fontOptions} ${classes.paragraphTextColor}`}>
                            This program works through libraries to offer  free robotics classes for kids which are conducted by First Lego League teams. 
                        </Typography>
                        <Typography variant="caption" color="inherit" className={`${classes.grow} ${classes.fontOptions} ${classes.paragraphTextColor}`}>
                            The Thunderbots a robotics team based in Sacramento, CA started this program by working with Orangevale Public Library. They worked with the library to purchase kits and design a robotics education program that could be offered in the library.
                            The classes are  scheduled  to be two hours each week and the library publishes information about the sessions. In each class, they teach a building and programming activity. The first couple of classes are designed be super simple to get the kids interested.  It is amazing to see what kids without any prior exposure to robotics or programming can accomplish and their excitement on building their first robot and getting it to move!
                        </Typography>
                        <Typography variant="caption" color="inherit" className={`${classes.grow} ${classes.fontOptions} ${classes.paragraphTextColor}`}>
                            The Thunderbots were motivated by the fact that they got to give local kids exposure to a great program totally free. Kids can nurture their interest in robotics and hopefully get interested to start their ownFIRST LEGO League team with this newfound knowledge. So they have now taken this program worldwide and help match interested libraries and team, and provide the framework including startup advise and  recommended curriculum for this program.
                        </Typography>
                    </Grid>  
                    {
                        innerWidth <= 480
                            ? null
                            : <Grid item xs={2} className={classes.centerText}></Grid>
                    }
                                                        
                </Grid>
                
                {/* <Grid container spacing={24}>                    
                    <Grid item xs={2} className={classes.centerText}></Grid>
                    <Grid item xs={8} className={classes.centerText}>
                        <Typography variant="h4" color="inherit" className={`${classes.grow} ${classes.headerTextColor}`}>
                            Our Awards & Achievements 
                        </Typography>
                        
                    </Grid> 
                    <Grid item xs={2} className={classes.centerText}></Grid>
                </Grid>

                <Grid container spacing={24}>
                    <Grid item xs={4}>
                        <Paper className={classes.paper}>
                            <Grid contlibrariainer spacing={8}>
                                <Gridlibrari librariitem xs={5}>                                    
                                      librari  <img src={require("../assets/image1.jpg")} className={classes.img} alt="Logo" height={150} />                                    
                                </Gridlibrari>
                                <Grid item xs={8} sm container>
                                    <Grid item xs={12} >
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            2013 First Lego League
                                        </Typography>
                                        <Typography gutterBottom>Rising Star Award</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={4}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={8}>
                                <Grid item xs={5}>
                                    <img src={require("../assets/image2.jpg")} className={classes.img} alt="Logo" height={150} />
                                </Grid>
                                <Grid item xs={8} sm container>
                                    <Grid item xs={12} >
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            2014 Challenge
                                        </Typography>
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            Northern California Official Qualifying Tournament
                                        </Typography>
                                        <Typography gutterBottom>Christian Brothers High School</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={4}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={8}>
                                <Grid item xs={5}>
                                    <img src={require("../assets/image5.jpg")} className={classes.img} alt="Logo" height={150} />
                                </Grid>
                                <Grid item xs={8} sm container>
                                    <Grid item xs={12} >
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            2014-2015 Challenge
                                        </Typography>
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            Northern California Capitol District FLL Champianship Tournament
                                        </Typography>
                                        <Typography gutterBottom>Programming Award, 2nd Place</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={4}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={8}>
                                <Grid item xs={5}>                                    
                                        <img src={require("../assets/image3.jpg")} className={classes.img} alt="Logo" height={150} />                                    
                                </Grid>
                                <Grid item xs={8} sm container>
                                    <Grid item xs={12} >
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            2015-2016 Challenge
                                        </Typography>
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            Northern California Official Qualifying Tournament, organized by FTC 5901
                                        </Typography>
                                        <Typography gutterBottom>CHAMPION'S AWARD</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                    
                    <Grid item xs={4}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={8}>
                                <Grid item xs={5}>
                                    <img src={require("../assets/image6.jpg")} className={classes.img} alt="Logo" height={150} />
                                </Grid>
                                <Grid item xs={8} sm container>
                                    <Grid item xs={12} >
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            2015-2016 Challenge
                                        </Typography>
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            Northern California Capitol District FLL Champianship Tournament
                                        </Typography>
                                        <Typography gutterBottom>Mechanical Design Award, 1st Place</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={4}>
                        <Paper className={classes.paper}>
                            <Grid container spacing={8}>
                                <Grid item xs={5}>
                                    <img src={require("../assets/image4.jpg")} className={classes.img} alt="Logo" height={150} />
                                </Grid>
                                <Grid item xs={8} sm container>
                                    <Grid item xs={12} >
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            2016-2017 Challenge
                                        </Typography>
                                        <Typography gutterBottom variant="body2" style={{ fontWeight: 'bold' }}>
                                            Northern California Official Qualifying Tournament, Interl, Folsom,
                                        </Typography>
                                        <Typography gutterBottom>Project Award</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                </Grid> */}

                

                {/* <Grid container spacing={24}>
                    <Grid item xs={2} className={classes.centerText}></Grid>
                    <Grid item xs={8} className={classes.centerText}>
                        <Typography variant="h4" color="inherit" className={`${classes.grow} ${classes.fontOptions}`}>
                            Thunderbots Team
                        </Typography>
                    </Grid>
                    <Grid item xs={2} className={classes.centerText}></Grid>
                </Grid>
                <Grid container spacing={24}>
                    <GridList cellHeight={180} className={classes.gridList}>
                        {this.state.tileData.map(tile => (
                            <GridListTile key={tile.img}>
                                <img src={tile.img} alt={tile.title} className={classes.image} />
                                <GridListTileBar
                                    title={tile.title}
                                    style={{ fontSize: 10 }}
                                />
                            </GridListTile>
                        ))}
                    </GridList>                 
                </Grid>
             */}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoginSuccess: state.SessionReducer.isLoginSuccess
   }
}

Home.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles),connect(mapStateToProps))(Home);

